import * as ExpoFileSystem from 'expo-file-system';
import { Platform, Share } from 'react-native';

export const useBase64Downloader = () => {
  const downloadBase64 = async (base64: string, fileName: string, fileType: 'pdf' | 'zip') => {
    if (Platform.OS === 'web') {
      // file is base64 encoded, we must convert it to binary
      const byteCharacters = atob(base64);
      const byteNumbers = new Array(byteCharacters.length);

      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: `application/${fileType}` });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${fileName}.${fileType}`);
      document.body.appendChild(link);
      link.click();
    } else {
      const uri = `${ExpoFileSystem.cacheDirectory}${fileName}.${fileType}`;
      await ExpoFileSystem.writeAsStringAsync(uri, base64, {
        encoding: ExpoFileSystem.EncodingType.Base64,
      });

      await Share.share({
        url: uri,
        title: `${fileName}.${fileType}`,
      });
    }
  };

  return {
    downloadBase64,
  };
};
